var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 3.375C10.125 3.99632 9.6213 4.5 9 4.5C8.3787 4.5 7.875 3.99632 7.875 3.375C7.875 2.75368 9 1.5 9 1.5C9 1.5 10.125 2.75368 10.125 3.375Z",
    stroke: "#626F86",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5V6.75",
    stroke: "#626F86",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.5C14.4236 10.5 15.375 9.66052 15.375 8.625C15.375 7.58948 14.4236 6.75 13.25 6.75H4.75C3.5764 6.75 2.625 7.58948 2.625 8.625C2.625 9.66052 3.5764 10.5 4.75 10.5C5.77806 10.5 6.67811 9.85583 6.875 9C7.07189 9.85583 7.97197 10.5 9 10.5C10.028 10.5 10.9281 9.85583 11.125 9C11.3219 9.85583 12.2219 10.5 13.25 10.5Z",
    stroke: "#626F86",
    strokeWidth: 1.4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.5L4.14067 12.4347C4.53399 14.3826 4.73066 15.3565 5.39706 15.9283C6.06347 16.5 7.00206 16.5 8.87925 16.5H9.12075C10.9979 16.5 11.9365 16.5 12.6029 15.9283C13.2694 15.3565 13.466 14.3826 13.8593 12.4347L14.25 10.5",
    stroke: "#626F86",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAge);
export default __webpack_public_path__ + "static/media/age.2ff087a4983652528d51d47a74de9e85.svg";
export { ForwardRef as ReactComponent };